export default __webpack_public_path__ + "static/media/whychooseicon3.5c3699d7.png";